import { QueryClient } from "@tanstack/react-query";

/**
 * Northstar data is read-mostly and mutates infrequently — the defaults bias
 * toward fresh data over aggressive caching. Mutations re-fetch their relevant
 * queries directly via `invalidateQueries` rather than relying on stale-time.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
